module.exports = __webpack_public_path__ + "img/se6.d724fec9.jpg";